import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 40px;
`
